export default __webpack_public_path__ + "static/media/bootstrap.5bbc83e3.jpeg";